"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetailsHours = _interopRequireDefault(require("../../styles/dealer-details-hours.css"));
var _dealerHoursList = _interopRequireDefault(require("./dealer-hours-list"));
var _types = _interopRequireDefault(require("../types"));
var DealerHours = function DealerHours(_ref) {
  var dealerDepartments = _ref.dealerDepartments,
    saleOpeningHoursLabel = _ref.saleOpeningHoursLabel,
    serviceOpeningHoursLabel = _ref.serviceOpeningHoursLabel,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _dealerDetailsHours["default"].hoursContainer
  }, dealerDepartments.map(function (department, index) {
    return /*#__PURE__*/_react["default"].createElement(_dealerHoursList["default"], {
      department: department,
      key: index,
      saleOpeningHoursLabel: saleOpeningHoursLabel,
      serviceOpeningHoursLabel: serviceOpeningHoursLabel,
      theme: theme
    });
  }));
};
var _default = DealerHours;
exports["default"] = _default;